
const routes = [
  {
    title: '客户账户管理',
    path: '/CustAccoutManage',
    name: 'CustAccoutManage',
    meta: {
      title: '客户账户管理'
    },
    component: () => import('../../views/CustAccoutManage.vue')
  },
  {
    title: '文件下载',
    path: '/DownloadFile',
    name: 'DownloadFile',
    meta: {
      title: '文件下载'
    },
    component: () => import('../../views/DownLoadFile.vue')
  }
];

export default routes;
